import React from 'react';
import { Form, Formik } from 'formik';
import { Box, Button, Grid } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { ISettingsGroups } from '../interfaces';
import { useSaveAppSettings } from '../hooks';
import { validateAppSettings } from '../validation';
import NPSSettings from './NPSSettings';
import ApplicationSettings from './ApplicationSettings';
import DefectActSettings from './DefectActSettings';
import TechMapSettings from './TechMapSettings';
import MobileAppSettings from './MobileAppSettings';
import PartnersSettings from './PartnersSettings';
import CalculatorTariffSettings from './CalculatorTariffSettings';

interface IProps {
  settings: ISettingsGroups;
  onSave(values: ISettingsGroups): void;
}

const AppSettingsForm = ({ settings }: IProps) => {
  const { disabled, handleSaveAppSettings } = useSaveAppSettings();

  return (
    <Formik
      initialValues={{ settings }}
      validate={validateAppSettings}
      onSubmit={({ settings }) => handleSaveAppSettings(settings)}
    >
      <Form>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <PartnersSettings disabled={disabled} />
              </Grid>

              <Grid item xs={12}>
                <NPSSettings disabled={disabled} />
              </Grid>

              <Grid item xs={12}>
                <DefectActSettings disabled={disabled} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={6} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ApplicationSettings disabled={disabled} />
              </Grid>

              <Grid item xs={12}>
                <MobileAppSettings disabled={disabled} />
              </Grid>

              <Grid item xs={12}>
                <TechMapSettings disabled={disabled} />
              </Grid>

              <Grid item xs={12}>
                <CalculatorTariffSettings disabled={disabled} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" color="primary" variant="contained" startIcon={<Save />} disabled={disabled}>
                Сохранить изменения
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
};

export default AppSettingsForm;
